export const BOOKING_QUESTION_TYPES = [
  'short_text',
  'long_text',
  'dropdown',
  'multiple_choice',
  'checkboxes',
] as const;

export type BookingQuestionType = (typeof BOOKING_QUESTION_TYPES)[number];

export const CHOICE_BOOKING_QUESTION_TYPES = [
  'dropdown',
  'multiple_choice',
  'checkboxes',
] as const satisfies readonly BookingQuestionType[];

export const BOOKING_QUESTION_ORIGINS = ['owner', 'seeded_message'] as const;

export type BookingQuestionOrigin = (typeof BOOKING_QUESTION_ORIGINS)[number];

// Every character cap counts Unicode code points (countCodePoints), never UTF-16 units.
export const MAX_BOOKING_QUESTIONS = 25;

export const MAX_BOOKING_QUESTION_OPTIONS = 25;

export const MAX_BOOKING_QUESTION_LABEL_CHARS = 200;

export const MAX_BOOKING_QUESTION_OPTION_CHARS = 100;

export const MAX_SHORT_TEXT_ANSWER_CHARS = 200;

export const MAX_LONG_TEXT_ANSWER_CHARS = 2000;
